import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AppComponent } from './app.component';
import { BookACallComponent } from './public/book-a-call/book-a-call.component';

const routes: Routes = [
  {
    path: '',
    component: AppComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('./public/public.module').then((m) => m.PublicModule),
      },
      {
        path: '',
        // resolve: { },
        loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule),
      },
      {
        path: '',
        loadChildren: () => import('./private/private.module').then((m) => m.PrivateModule),
      },
      {
        path: 'error/:code',
        loadChildren: () => import('./error/error.module').then((m) => m.ErrorModule),
      },
      { path: 'auth/signin', redirectTo: 'google_auth' },
      { path: 'auth/setup/:token', redirectTo: 'activate/:token' },
      { path: 'auth/reset/:token', redirectTo: 'reset/:token' },
      {
        path: 'r2b',
        loadChildren: () => import('./r2b/r2b.module').then((m) => m.R2bModule),
      },
    ],
  },
  {
    path: 'book-a-call', component: BookACallComponent,
  },
  {
    path: '**',
    redirectTo: '/error/404',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: false,
      preloadingStrategy: PreloadAllModules,
      relativeLinkResolution: 'legacy',
    }),
  ],
  exports: [RouterModule],
  providers: [],
})
export class AppRoutingModule { }
